module.exports = __webpack_public_path__ + "img/analysisTool.cf84e1a9.svg";